<template>
        <div
        class="frame"
        v-bind:class="color"
        >
            <KZNumber
            v-for="(number, key) in arrayOfNumbers"
            :key="key"
            :number="number"/>
        </div>
</template>

<script>
import KZNumber from './KZNumber.vue';

export default {
  name: 'KZFrame',
  props: {
    color: String,
    sum: String,
  },
  components: { KZNumber },
  computed: {
    arrayOfNumbers() {
      const { sum } = this;
      const intNumber = parseInt(sum, 10);
      const arrayOfNumbers = String(intNumber).split('');
      return arrayOfNumbers;
    },
  },
};
</script>

<style scoped>
.frame {
    display: flex;
    width: 760px;
    height: 120px;
    align-items: center;
    justify-content: center;
    background: none;
    border: 4px solid #dcb200;
    border-radius: 25px;
    background: url('../../../assets/images/frame.png') no-repeat center;
    background-size: 120% 120%;
    font-size: 4rem;
    color:#dcb200;
}
.gray {
    background-color: #131313;
}
.blue {
    background-color: #002135;
}
.green {
    background-color: #091a00;
}
.orange {
    background-color: #831f00;
}
.red {
    background-color: #5f0200;
}
</style>
